<template>
<div>

  <label for="season"><strong>STAGIONE</strong></label>
  <div v-if="props.type"  class="form-group">
    
    <select id="season" :required="props.required" :disabled="!props.isActive" @change="$emit('update',seasonId,$event)" class="form-control" v-model="seasonId">
      <option v-if="props.optionBase==true" value="0"> -- TUTTE LE STAGIONI -- </option>  
      <option v-for="(item,index) in items" :value="item.seasonId" :key="index">
        <strong>{{item.season}}</strong>
        </option>        
    </select>  
  </div>

  <div v-else v-for="(item,index) in items" :key="index" >
  
  <div class="form-check form-check-inline">
    <input @click="setSeason(index)" type="checkbox" class="form-check-input" :id="'exampleCheck_'+index" :value="item.seasonId">
    <label class="form-check-label"  :for="'exampleCheck_'+index">{{item.season}}</label>
  </div>
   
  </div>  


</div>



</template>
<script>
import api             from "@/api";

export default {
  props : ["props"] , 
  components: {},
  data() {
    return {

      seasonId               : 0,
      items                  : [],
      selection              : [],
      spinner                : false

     
    };
  },
  mounted: function() {
  
  },
  created: function() {
      this.getData()
  },
  methods: 
  {
    setSeason(index)
    {
      var arr = []
      if(this.selection.indexOf(this.items[index]['seasonId']) == -1)
      {
        this.selection.push(this.items[index]['seasonId'])

      }
      else
      {
        arr = this.selection.filter(item => item != this.items[index]['seasonId'])
        this.selection = arr
      }
      
      var temp = []
      if(this.selection.length==0)
      {
        temp = []
        this.items.forEach(
          item =>{
            temp.push(item.seasonId)
          }
        )
      }
      else
      {
        temp = this.selection
      }
      this.$emit('update',temp)
      

    },
    async getData()
    {      
      var json   = {'sp'    : 'spSeasonSelect'}
      await api.post(json).then(res => {
      
      
        if(res.status==200)
          { 
            this.items   = res.data.recordsets[0]          
            this.seasonId = this.props.Id 
          }
          else if(res.status==500)
          {
            console.log(res.data)

          } 
          else
          {
            console.log('Network Error.')                  
          } 
        

      }).catch(err => {
        console.log(err.message)    
        }).finally(() => {
        this.spinner = false
        });

      

      



    },
  
    
    
  
}

}
</script>
<style scoped>

select{
    _font-weight: bold;
    _color: blue;

}

.form-check-label{
  cursor:pointer
}
</style>